<template>
  <header class="topbar">
    <a href="#top" class="brand">
      <span class="brand-mark">B</span>
      <span>Bisrat</span>
    </a>
    <nav class="top-links" aria-label="Sections">
      <a v-for="link in links" :key="link.href" :href="link.href">{{ link.label }}</a>
    </nav>
    <a :href="contact" class="top-cta">Say hi</a>
  </header>

  <nav class="pill" :class="{ shown: scrolled }" aria-label="Sections">
    <a
      v-for="link in links"
      :key="link.href"
      :href="link.href"
      :class="{ active: active === link.href }"
    >{{ link.label }}</a>
    <a :href="contact" class="pill-cta">Say hi</a>
  </nav>
</template>

<script>
export default {
  name: 'SiteNav',
  data() {
    return {
      scrolled: false,
      active: '',
      contact: 'mailto:dev.bizzy@gmail.com',
      links: [
        { label: 'LifeOS', href: '#lifeos' },
        { label: 'Quant', href: '#quant' },
        { label: 'Jarvis', href: '#jarvis' },
        { label: 'AgendaVue', href: '#agendavue' },
        { label: 'Experience', href: '#experience' },
      ],
    };
  },
  mounted() {
    this.onScroll = () => {
      this.scrolled = window.scrollY > 420;
      const mid = window.innerHeight * 0.4;
      let current = '';
      for (const link of this.links) {
        const el = document.querySelector(link.href);
        if (el && el.getBoundingClientRect().top < mid) current = link.href;
      }
      this.active = current;
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>

<style scoped>
.topbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 22px 32px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: -0.01em;
}

.brand-mark {
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--text);
  color: var(--bg);
  font-size: 15px;
  font-weight: 700;
}

.top-links {
  display: flex;
  gap: 36px;
  font-size: 15px;
  color: var(--text-dim);
}

.top-links a:hover,
.top-cta:hover {
  color: var(--text);
}

.top-cta {
  justify-self: end;
  padding: 9px 18px;
  border-radius: 999px;
  border: 1px solid var(--line-strong);
  background: rgba(255, 255, 255, 0.04);
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
}

.top-cta:hover {
  background: rgba(255, 255, 255, 0.1);
}

.pill {
  position: fixed;
  top: 14px;
  left: 50%;
  z-index: 30;
  display: flex;
  gap: 2px;
  padding: 6px;
  border-radius: 999px;
  background: rgba(38, 38, 42, 0.72);
  border: 1px solid var(--line);
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
  transform: translate(-50%, -140%);
  opacity: 0;
  transition: transform 0.6s var(--ease), opacity 0.4s;
}

.pill.shown {
  transform: translate(-50%, 0);
  opacity: 1;
}

.pill a {
  padding: 9px 16px;
  border-radius: 999px;
  font-size: 14px;
  color: var(--text-dim);
  white-space: nowrap;
  transition: color 0.2s, background 0.2s;
}

.pill a:hover,
.pill a.active {
  color: var(--text);
}

.pill a.active {
  background: rgba(255, 255, 255, 0.06);
}

.pill .pill-cta {
  margin-left: 4px;
  background: #0e0e10;
  color: var(--text);
  font-weight: 500;
}

@media (max-width: 760px) {
  .topbar { grid-template-columns: 1fr auto; padding: 18px 16px; }
  .top-links { display: none; }
  .pill {
    max-width: calc(100vw - 24px);
    overflow-x: auto;
    scrollbar-width: none;
  }
  .pill::-webkit-scrollbar { display: none; }
  .pill a { padding: 8px 12px; font-size: 13px; }
}
</style>
